// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"efdcd712","250":"415fc0de"}[chunkId] + ".chunk.js";
};